import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { AreaType } from './types'

interface NewProps {
  area: AreaType
  communities: {
    id: string
    name: string
  }[]
}

export default function New({ area, communities }: NewProps) {
  return (
    <>
      <Head title="New area" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">New area</h1>

        <Form
          area={area}
          communities={communities}
          method="post"
          action="/areas"
          submitText="Create Area"
        />

        <Link
          href="/areas"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to areas
        </Link>
      </div>
    </>
  )
}
